__turbopack_context__.v({
  "arrow": "P9vb8G_arrow",
  "arrowBounce": "P9vb8G_arrowBounce",
  "iconPulse": "P9vb8G_iconPulse",
  "stepIcon": "P9vb8G_stepIcon",
});
